module.exports = __webpack_public_path__ + "img/home_menu_9_selected.fd3b7719.png";